import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { Preview } from '../../../../helpers/ui/FileInput'
import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'

class DetailView extends Component {

    detailBloc = new DetailBloc()
    // test

    constructor(props) {
        super(props)
        this.state = {
            detail: {
                employee_current : null,
                employee_leader: null
            },
            skp: []
        }
    }

     componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            skp: response.detail_skp
                        })
                       //console.log(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })

       

    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Detail SKP SIMANTAB</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail SKP SIMANTAB
                                    </CardSubtitle>
                                    <hr />

                                    <Row>
                                        <Col className="col-6">
                                            <Table striped   variant="dark">
                                                <thead>
                                                    <tr>
                                                        <th colspan="2" className="text-center">PEGAWAI YANG DINILAI</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td width="200">Nama</td>
                                                        <td>
                                                             {
                                                                this.state.detail.employee_current ?
                                                                    <>{this.state.detail.employee_current.employee_full_name !== "" ? this.state.detail.employee_current.employee_full_name : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>NIP</td>
                                                          <td>
                                                             {
                                                                 this.state.detail.employee_current ?
                                                                    <>{this.state.detail.employee_current.employee_nip !== "" ? this.state.detail.employee_current.employee_nip : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pangkat / Golongan</td>
                                                          <td>
                                                             {
                                                                 this.state.detail.employee_current ?
                                                                    <>{this.state.detail.employee_current.employee_current_rank_group_room !== "" ? this.state.detail.employee_current.employee_current_rank_group_room : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Jabatan</td>
                                                         <td>
                                                             {
                                                                 this.state.detail.employee_current ?
                                                                    <>{this.state.detail.employee_current.employee_current_position_name !== "" ? this.state.detail.employee_current.employee_current_position_name : '-'}</>
                                                                :<div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Unit Kerja</td>
                                                          <td>
                                                             {
                                                               this.state.detail.employee_current ?
                                                                    <>{this.state.detail.employee_current.employee_current_work_unit_name !== "" ? this.state.detail.employee_current.employee_current_work_unit_name : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                        <Col className="col-6">
                                            <Table striped   variant="dark">
                                            <thead>
                                                    <tr>
                                                        <th colspan="2" className="text-center">PEJABAT PENILAI PEKERJA</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                        <td width="200">Nama</td>
                                                        <td>
                                                             {
                                                                this.state.detail.employee_leader ?
                                                                    <>{this.state.detail.employee_leader.employee_full_name !== "" ? this.state.detail.employee_leader.employee_full_name : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>NIP</td>
                                                          <td>
                                                             {
                                                                this.state.detail.employee_leader ?
                                                                    <>{this.state.detail.employee_leader.employee_nip !== "" ? this.state.detail.employee_leader.employee_nip : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Pangkat / Golongan</td>
                                                          <td>
                                                             {
                                                                this.state.detail.employee_leader ?
                                                                    <>{this.state.detail.employee_leader.employee_current_rank_group_room !== "" ? this.state.detail.employee_leader.employee_current_rank_group_room : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Jabatan</td>
                                                         <td>
                                                             {
                                                                this.state.detail.employee_leader ?
                                                                    <>{this.state.detail.employee_leader.employee_current_position_name !== "" ? this.state.detail.employee_leader.employee_current_position_name : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Unit Kerja</td>
                                                          <td>
                                                             {
                                                               this.state.detail.employee_leader ?
                                                                    <>{this.state.detail.employee_leader.employee_current_work_unit_name !== "" ? this.state.detail.employee_leader.employee_current_work_unit_name : '-'}</>
                                                                : <div style={{width: 68, height: 15}}>-</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-12">
                                            <Table striped bordered hover variant="dark">
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>IK</th>
                                                        <th>NO IK</th>
                                                        <th>Tahun</th>
                                                        <th>Target</th>
                                                        <th>Sasaran</th>
                                                        <th>No Sasaran</th>
                                                        <th>Sasaran Label</th>
                                                        <th>Sub Unit Kerja</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                     {this.state.skp.map(( listValue, index ) => {
                                                      return (
                                                        <tr key={index}>
                                                          <td>{parseInt(index) + 1}</td>
                                                          <td>{listValue.endpoint_ik}</td>
                                                          <td>{listValue.endpoint_noik}</td>
                                                          <td>{listValue.endpoint_tahun}</td>
                                                          <td>{listValue.endpoint_target}</td>
                                                          <td>{listValue.endpoint_sasaran}</td>
                                                          <td>{listValue.endpoint_no_sasaran}</td>
                                                          <td>{listValue.endpoint_sasaran_label}</td>
                                                          <td>{listValue.endpoint_unker_parent_name}</td>
                                                        </tr>
                                                      );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                   
                                    <Link to="/kepegawaian/skp.html" className="waves-effect">
                                        <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                    </Link>
                                   
                                    
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(DetailView);